class ConsultationFormHandler {
  constructor() {
    this.consultationForm = document.getElementById('consultation-form');
    this.steps = document.querySelectorAll(".form-step");
    this.nextBtn = document.querySelector(".next-btn");
    this.prevBtn = document.querySelector(".prev-btn");
    this.submitBtn = document.querySelector(".submit-btn");
    this.femaleQuestions = document.getElementById("female-questions");
    this.maleAssessment = document.getElementById("male-assessment");
    this.pregnancyWarning = document.querySelector(".pregnancy-warning");
    this.pregnancyGroup = document.querySelector('[data-group="Pregnancy"]');
    this.resultsSection = document.querySelector(".results-section");
    this.maleProductsContainer = document.querySelector(".male-products");
    this.femaleResultUrl = document.querySelector(".final-step")?.dataset.femaleResultUrl;
    this.stepNumbers = document.querySelectorAll(".step-number");
    this.spinner = document.getElementById('form-spinner');
    this.currentStep = 0;

    this.init();
  }

  init() {
    this.updateSteps();
    this.addEventListeners();
  }

  addEventListeners() {
    this.nextBtn.addEventListener("click", () => this.handleNextStep());
    this.prevBtn.addEventListener("click", () => this.handlePrevStep());
    this.submitBtn.addEventListener("click", (event) => this.handleSubmit(event));

    document.querySelectorAll('input[name="Birth Gender"]').forEach((radio) => {
      radio.addEventListener("change", () => this.handleGenderChange());
    });

    document.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener("change", () => this.toggleConditionalInputs());
    });
  }

  handleGenderChange() {
    const gender = document.querySelector('input[name="Birth Gender"]:checked')?.value;
    const maleChoiceList = this.maleAssessment.querySelector(".custom-choice-list");

    if (gender === "female") {
      this.femaleQuestions.style.display = "block";
      this.pregnancyGroup.setAttribute("data-required", "true");

      this.maleAssessment.style.display = "none";
      if (maleChoiceList) maleChoiceList.removeAttribute("data-required");

      this.pregnancyWarning.style.display = "none";
    } else if (gender === "male") {
      this.femaleQuestions.style.display = "none";
      this.pregnancyGroup.removeAttribute("data-required");
      this.pregnancyWarning.style.display = "none";

      this.maleAssessment.style.display = "block";
      if (maleChoiceList) maleChoiceList.setAttribute("data-required", "true");
    }
  }

  showSpinner() {
    this.spinner.classList.remove('hidden');
  }

  hideSpinner() {
    this.spinner.classList.add('hidden');
  }

  clearErrors(step) {
    step.querySelectorAll(".error-message").forEach((e) => {
      e.textContent = "";
      e.style.display = "none";
    });
  }

  showError(el) {
    const error = el.closest(".form-group")?.querySelector(".error-message");
    if (error) {
      error.textContent = "This field is required.";
      error.style.display = "block";
    }
  }

  validateStep(step) {
    let valid = true;
    this.clearErrors(step);

    step.querySelectorAll('[data-required="true"]').forEach((el) => {
      if (el.offsetParent === null) return; 
      if (el.tagName === "UL") {
        const group = el.dataset.group;
        const checked = step.querySelector(`input[name="${group}"]:checked`);
        if (!checked) {
          this.showError(el);
          valid = false;
        }
      } else if (!el.value.trim()) {
        this.showError(el);
        valid = false;
      }
    });

    const gender = document.querySelector('input[name="Birth Gender"]:checked')?.value;
    const pregnancy = document.querySelector('input[name="Pregnancy"]:checked')?.value;

    if (gender === "female") {
      this.femaleQuestions.style.display = "block";
      this.pregnancyGroup.setAttribute("data-required", "true");

      if (!pregnancy) {
        this.showError(document.querySelector('input[name="Pregnancy"]'));
        valid = false;
      } else if (pregnancy === "yes") {
        this.pregnancyWarning.style.display = "block";
        valid = false;
      } else {
        this.pregnancyWarning.style.display = "none";
      }
    } else {
      this.femaleQuestions.style.display = "none";
      this.pregnancyGroup.removeAttribute("data-required");
      this.pregnancyWarning.style.display = "none";
    }

    if (gender === "male") {
      this.maleAssessment.style.display = "block";
    } else {
      this.maleAssessment.style.display = "none";
    }

    return valid;
  }

  handleNextStep() {
    const currentForm = this.steps[this.currentStep];
    if (this.validateStep(currentForm)) {
      this.showSpinner();
      setTimeout(() => {
        this.currentStep++;
        this.updateSteps();
        this.hideSpinner();
      }, 500);
    }
  }

  handlePrevStep() {
    if (this.currentStep > 0) {
      this.showSpinner();
      setTimeout(() => {
        this.currentStep--;
        this.updateSteps();
        this.hideSpinner();
      }, 300);
    }
  }

  updateSteps() {
    this.steps.forEach((step, i) => {
      step.style.display = i === this.currentStep ? "block" : "none";
    });

    this.nextBtn.innerText = this.currentStep === 0 ? "I agree" : "Next";
    this.prevBtn.style.display = this.currentStep > 1 ? "inline-block" : "none";
    this.nextBtn.style.display = this.currentStep < this.steps.length - 1 ? "inline-block" : "none";
    this.submitBtn.style.display = this.currentStep === this.steps.length - 1 ? "inline-block" : "none";

    this.updateStepIndicator();
    this.toggleConditionalInputs();
  }

  updateStepIndicator() {
    this.stepNumbers.forEach((step, index) => {
      if (this.currentStep > 0) {
        step.closest(".steps-indicator").style.display = "block";
        const stepIndex = index + 1;
        if (stepIndex < this.currentStep) {
          step.classList.add("completed");
          step.classList.remove("active");
        } else if (stepIndex === this.currentStep) {
          step.classList.add("active");
          step.classList.remove("completed");
        } else {
          step.classList.remove("active", "completed");
        }
      } else {
        step.classList.remove("active", "completed");
      }
    });
  }

  toggleConditionalInputs() {
    document.querySelectorAll(".toggle-text").forEach((ul) => {
      const group = ul.dataset.group;
      const yesOption = ul.querySelector(`input[name="${group}"][value="yes"]`);
      const input = ul.closest(".form-group")?.querySelector(".conditional-text");

      if (yesOption?.checked && input) {
        input.style.display = "block";
        input.setAttribute("data-required", "true");
      } else if (input) {
        input.style.display = "none";
        input.removeAttribute("data-required");
      }
    });
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.showSpinner();

    const formEl = document.getElementById("multiStepForm");
    const inputs = formEl.querySelectorAll("input, textarea, select");
    const snapFormData = {};

    inputs.forEach((el) => {
      const name = el.name;
      const type = el.type;
      if (!name) return;

      if (type === "radio") {
        if (el.checked) snapFormData[name] = el.value;
      } else if (type === "checkbox") {
        if (!snapFormData[name]) snapFormData[name] = [];
        if (el.checked) snapFormData[name].push(el.value);
      } else {
        snapFormData[name] = el.value;
      }
    });

    const payload = { formdata: snapFormData };
    console.table(snapFormData);

    try {
      const res = await fetch("https://snapforms-umber.vercel.app/api/snapforms", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (res.status === 422) {
        const { validationErrors } = await res.json();
        console.error("Validación:", validationErrors);
        this.hideSpinner();
        return;
      }

      if (!res.ok) throw new Error(await res.text());

      this.hideSpinner();
      this.handleGenderStep();
    } catch (err) {
      console.error("Error al enviar a SnapForms:", err);
      this.hideSpinner();
    }
  }

  handleGenderStep() {
    const gender = document.querySelector('input[name="Birth Gender"]:checked')?.value;
    if (gender === "male") {
      this.resultsSection.style.display = "block";
      this.maleProductsContainer.style.display = "grid";
      this.nextBtn.style.display = "none";
      this.prevBtn.style.display = "none";
      this.submitBtn.style.display = "none";
      this.steps[this.steps.length - 1].style.display = "none";
    } else if (gender === "female") {
      window.location.href = this.femaleResultUrl;
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new ConsultationFormHandler();
});
